import React from 'react';
import { Form, Field } from 'react-final-form';
import { Link } from 'react-router-dom';

import logo from 'modules/ui/assets/images/logo.png';
import { TextInput, Button, InputError } from 'modules/ui/components';
import { HighlightedSm, RegularSm } from 'modules/ui/typography';
import { Routes } from 'Routes';
import { validateEmail } from 'modules/form';
import { AuthImageContainer } from '../../components';
import { useResetPassword } from '../../hooks';
import {
  FormContainer,
  LogoImage,
  LinksContainer,
  Title,
} from './styledComponents';

const ResetPasswordPageUi: React.FC = () => {
  const { error, success, loading, handleResetPassword } = useResetPassword();

  return (
    <AuthImageContainer>
      <FormContainer>
        <LogoImage src={logo} alt="Dorado sail" />
        <Title>Reset password</Title>
        <Form
          onSubmit={handleResetPassword}
          initialValues={{ email: '' }}
          render={({ handleSubmit, invalid }): React.ReactNode => (
            <form>
              <div className="field-container">
                <Field
                  name="email"
                  type="email"
                  component={TextInput}
                  width={320}
                  label="Email"
                  placeholder="example@mail.com"
                  validate={validateEmail}
                />
                {error !== null && (
                  <InputError>
                    There was an error, please try again with a different email.
                  </InputError>
                )}
                {success && (
                  <RegularSm>
                    If an account with that email exists, you will receive a
                    password reset link shortly.
                  </RegularSm>
                )}
              </div>
              <Button
                disabled={invalid || success}
                stretch
                label="Reset password"
                isLoading={loading}
                clickHandler={handleSubmit}
                type="submit"
              />
              <LinksContainer>
                <RegularSm>
                  <Link to={Routes.Login}>
                    <HighlightedSm>Back to login</HighlightedSm>
                  </Link>
                </RegularSm>
              </LinksContainer>
            </form>
          )}
        />
      </FormContainer>
    </AuthImageContainer>
  );
};

export const ForgotPage = React.memo(ResetPasswordPageUi);
